interface PrintLinkProps {
  onClick: () => void;
  loading?: boolean;
}

export default function PrintLink({ onClick, loading }: PrintLinkProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      className="text-xs font-medium text-gray-500 hover:text-brand-500 dark:text-gray-400 dark:hover:text-brand-400 disabled:opacity-50"
    >
      {loading ? "..." : "Print"}
    </button>
  );
}
